<script>
import { resetPassword } from '@/api'
import md5 from 'md5'
import store from '@/store'
export default {
  name: 'PasswordChange',
  data () {
    return {
      form: this.$form.createForm(this)
    }
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          if (values.newPwd !== values.newPwdConfirm) {
            this.$message.error(this.$t('user.password.change.passwordReview.not.match'))
            return false
          }
          resetPassword({ old_password: md5(values.oldPwd), new_password: md5(values.newPwd) }).then(res => {
             if (res.code === 0) {
               this.$message.success(this.$t('user.password.reset.success'))
               setTimeout(() => {
                 store.dispatch('Logout').then(() => {
                   window.location.href = '/'
                 }).catch(err => {
                   this.$message.error(err.message)
                 })
               }, 2000)
             } else {
               this.$message.error(res.msg)
             }
          })
        }
      })
    }
  }
}
</script>

<template>
  <div style="width: 100%;padding: 8px;">
    <div>
      <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" @submit="handleSubmit">
        <a-form-item :label="$t('user.password.change.password.current')">
          <a-input
            type="password"
            :placeholder="$t('user.password.change.password.current.tip')"
            v-decorator="['oldPwd', { rules: [{ required: true, message: $t('user.password.change.password.current.tip') },{ pattern: /^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z\d@#%!^&*]{8,20}$/, message: $t('user.password.change.password.format.error') }] }]"
          />
        </a-form-item>
        <a-form-item :label="$t('user.password.change.password.new')">
          <a-input
            type="password"
            v-decorator="[
              'newPwd',
              { rules: [{ required: true, message: $t('user.password.change.password.new.tip') },{ pattern: /^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z\d@#%!^&*]{8,20}$/, message: $t('user.password.change.password.format.error') }] },
            ]"
            :placeholder="$t('user.password.change.password.new.tip')"
          >
          </a-input>
        </a-form-item>
        <a-form-item :label="$t('user.password.change.passwordReview.new')">
          <a-input
            type="password"
            v-decorator="[
              'newPwdConfirm',
              { rules: [{ required: true, message: $t('user.password.change.passwordReview.new.tip') },{ pattern: /^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z\d@#%!^&*]{8,20}$/, message: $t('user.password.change.password.format.error') }] },
            ]"
            :placeholder="$t('user.password.change.passwordReview.new.tip')"
          >
          </a-input>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 12, offset: 6 }">
          <a-button type="primary" html-type="submit">
            {{ $t('user.password.change.password') }}
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<style scoped>

</style>
